// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yKYM","left":"styles_left__1fvwz"};